import angular from 'angular'
import ngRedux from 'ng-redux'
import { store } from '../state/store'

angular
  .module('webregister.vendor', [
    // Angular Modules
    'ngAnimate',
    'ngResource',
    'ngMessages',

    // Angular UI Modules
    'ui.router',

    // Vend Modules
    'vend.js',
    'vend.ui',
    'vendQuickKeys',
    ngRedux,
  ])
  .config(($ngReduxProvider: $TSFixMe) => {
    $ngReduxProvider.provideStore(store)
  })
